<template>
<div class="container">
<div  id="login-overlay" class="modal-dialog" style="max-width:500px;">
      
      <div class="modal-content">
          <div class="modal-header text-center" style="padding-top:0px !important;padding-bottom:0px !important;">
              <h2 >Welcome to Dupaws.com</h2>
          </div>
      
          <div class="modal-body" >
              <div class="row">
                  <div class="col-xs-12 col-sm-12" >
                      <div class="alert alert-danger alert-dismissible" v-if="error">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                   </button>
                <p>{{error}}</p>
            </div>

            <div class="alert alert-success alert-dismissible" v-if="notification">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                   </button>
                <strong></strong>{{notification}}
            </div>
                      <div class="well" style="margin-bottom:5px;">
                          <div>
                              <div class="form-group ">
                                  <label for="username" class="control-label">Email</label>
                                  <div class="inner-addon right-addon">
                                  <i v-show="errors.has('email')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('email')" v-if="credentials.username" class="fa fa-paw text-success "></i>
                                  <input type="email" name="email" v-validate="'required|email'" :class="{'input': true, 'has-error': errors.has('email') }" class="form-control" v-model="credentials.username" @keyup.enter="validateBeforeSubmit()" placeholder="Email address" lazy>
                                  </div>
                                  <span v-show="errors.has('email')" class="help-inline text-danger h5">{{ errors.first('email') }}</span>
                                  
                              </div>
                              <div class="form-group">
                                 <label for="password" class="control-label">Password</label>
                              <div class="inner-addon right-addon">
                                  <i v-show="errors.has('password')" class="fa fa-warning"></i>
                                  <i v-show="!errors.has('password')" v-if="credentials.password" class="fa fa-paw text-success "></i>
                                 <input type="password" name="password" class="form-control" v-validate="'required|min:4'" :class="{'input': true, 'has-error': errors.has('password') }" v-model="credentials.password" @keyup.enter="validateBeforeSubmit()" placeholder="Password" data-vv-delay="1000">
                                 </div>
                                  <span v-show="errors.has('password')" class="text-danger h5">{{ errors.first('password') }}</span>
                              </div>
                                
                              <button v-bind:disabled="filledRequiredComp==false" @click="validateBeforeSubmit()" class="btn btn-success btn-block btn-title">Login</button>
                          </div>
                        </div>
                  </div>
               
              </div>
              
          </div>
      </div>

  
  </div>
    </div>
</template>



<script>
  
  import auth from '../../auth/index'
  import store from '../../data/store'
  import Alert from '../SharedComponents/Alert.vue'
  

  export default {
    name: 'login',
    data() {
      return {  
        scrollPosition:'',
        credentials: {
          username: '',
          password: '',

        },
        notification:'',
        error: '',
        alert: false,
        alertMsg: '',

      }
    },
    updated(){
    var self = this
    $('input').focus(function (){
            self.scrollPosition = window.scrollY
            
    })
    $('input').blur(function (){
            // $(window).animate({ scrollTop: this.scrollPosition }, "slow");
            self.$SmoothScroll(self.scrollPosition, 350)
            
    })
  },
  methods: {
      validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // eslint-disable-next-line
          this.submit()
          return;
        }

        swal("Something is missing", "Please complete all the required fields to continue.", "info")
      });
    },
    submit() {
        $(window).scrollTop(0)
         var loginCreds = {
            grant_type: "password",
            username: this.credentials.username,
            password: this.credentials.password,
        }
        
        auth.login(this, loginCreds, 'sitters-dashboard')
        
        
        
      }
    },
    computed: {
      filledRequiredComp: function () {
        if (this.credentials.username == '' || this.credentials.password == '') {
          return false;
        } else {
          return true
        }
      },
      authenticatedComp: function(){
        return store.getters.authenticated
      },
      userRoleComp: function(){
        return store.getters.userRole
      }                
      
    },


    components: {
      Alert,
      
    }
  
  }
</script>


<style scoped>


</style>


// WEBPACK FOOTER //
// AdminLogin.vue?6c90ad7a